// Module
var code = "<component-loading data-bind=\"visible: isLoadingGpsSpeedData\"></component-loading>\n<div data-bind=\"if: highchartsOptions() && !isLoadingGpsSpeedData()\">\n    <div data-bind=\"highcharts: {options: highchartsOptions, chart: chart}, event: { mousedown: mousedown }\" class=\"chart voyage\"></div>\n</div>";
// Exports
module.exports = code;